import React, { useEffect } from 'react';
import { render } from 'react-dom';

export const useRenderCoreLegacyNotifications = () => {
    useEffect(() => {
        const element = document.querySelector(
            '.notification-box--listing > .js-notification-box',
        );

        if (!element) {
            return;
        }
        const type =
            element.attributes.getNamedItem('data-type')?.value || 'info';
        if (type === 'aaa') {
            return;
        }

        const message = element.attributes.getNamedItem('data-message')?.value;
        const linkText = element.attributes.getNamedItem('data-link-text')
            ?.value;

        const Link = () => {
            const link = element.attributes.getNamedItem('data-link')?.value;

            const closeBtn =
                element.attributes.getNamedItem('data-close-btn')?.value ||
                false;

            if (linkText) {
                return <a href={link}>{linkText}</a>;
            }

            if (closeBtn) {
                return (
                    <a
                        className="notification-bar__close"
                        onClick={() => {
                            render(<></>, element);
                        }}
                    >
                        <i className="ico-cross"></i>
                    </a>
                );
            }

            return <></>;
        };

        render(
            <div className={`notification-bar notification-bar--${type}`}>
                {message}
                {linkText ? ' ' : ''}
                <Link />
            </div>,
            element,
        );
    }, []);
};
